import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveLeaderboardDropAuthor } from "./WaveLeaderboardDropAuthor";
interface WaveLeaderboardDropHeaderProps {
  readonly drop: ExtendedDrop;
  readonly showAvatar?: boolean | undefined;
  readonly winningThreshold?: number | null | undefined;
}
export const WaveLeaderboardDropHeader: React.FC<WaveLeaderboardDropHeaderProps> = t0 => {
  const $ = _c(4);
  const {
    drop,
    showAvatar: t1,
    winningThreshold
  } = t0;
  const showAvatar = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== drop || $[1] !== showAvatar || $[2] !== winningThreshold) {
    t2 = <div className="tw-flex tw-min-w-0 tw-items-center"><WaveLeaderboardDropAuthor drop={drop} showAvatar={showAvatar} winningThreshold={winningThreshold} /></div>;
    $[0] = drop;
    $[1] = showAvatar;
    $[2] = winningThreshold;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};